module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-238.82aa9e6.woff2";